import { IQueueItemDto } from '@models';

export enum ItemPriority {
    low = 1,
    normal = 2,
    high = 3,
}

export type ItemPriorityValues = keyof typeof ItemPriority | 1 | 2 | 3;

export enum BulkCommitType {
    AllOrNothing = 'AllOrNothing',
    StopOnFirstFailure = 'StopOnFirstFailure',
    ProcessAllIndependently = 'ProcessAllIndependently',
}

export enum CSVFields {
    Reference = 'Reference',
    Deadline = 'Deadline',
    Priority = 'Priority',
    Postpone = 'Postpone',
}

export interface IBulkAddQueueItemsParameters {
    queueName: string;
    commitType: BulkCommitType;
    queueItems: IQueueItemDto[];
}

export interface ICSVQueueItemRow {
    [key: string]: string | number | boolean | undefined;

    Reference?: string;
    Deadline?: string;
    Priority?: string | number;
    Postpone?: string;
}

export interface IBulkAddQueueItemsFailedResponse {
    row: number;
    errorCode: string;
    errorMessage: string;
}

export interface IBulkAddQueueItemsResponse {
    success: boolean;
    message: string;
    failedItems: IBulkAddQueueItemsFailedResponse[];
}
